import ErrorManager from '@/common/utils/ErrorManager';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import { RootState } from '@/plugins/store';
import { ActionTree } from 'vuex';
import { MenuState } from './state';
import { LayoutAction, LayoutActionType } from '@/components/layout/store/action-types';
import { MENU } from '@/components/layout/store/mutation-types';
import SiteListService, { SiteSearchDTO } from '@/modules/SiteList/service/SiteListService';
import { http } from '@/common/utils/HttpServices';
import { Routes } from '@/api/Routes';


export const actions: ActionTree<MenuState, RootState> = {

    async [LayoutAction.GET_SITES]({ commit }: LayoutActionType): Promise<void> {
        SiteListService.getSiteList(new SiteSearchDTO(0, '', false))
            .then(async (response: any) => {
                if (response !== undefined || response?.status !== undefined) {
                    if (response.status !== 200) {
                        commit(`errorToaster/${ERROR.SET_MESSAGE}`,
                            await ErrorManager.processErrorCustomMessage(
                                response.status,
                                'app.error.undefined'
                            ),
                            { root: true }
                        );
                    }
                    commit(MENU.SET_SITES, response.data);
                } else {
                    commit(
                        `errorToaster/${ERROR.SET_MESSAGE}`,
                        await ErrorManager.processErrorCustomMessage(
                            response.status,
                            'app.error.undefined'
                        ),
                        { root: true }
                    );
                }
            }).catch(async error => {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processError(error),
                    { root: true }
                );
            });
    },

    async [LayoutAction.GET_STATUT_BIM]({ commit }: LayoutActionType): Promise<void> {
        http.get(Routes.ProjetRoutes.GetStatutBim())
            .then(async (response: any) => {
                if (response !== undefined && response?.status === 200) {
                    commit(MENU.SET_STATUT_BIM, response.data);
                }
            }).catch(async error => {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processError(error),
                    { root: true }
                );
            });
    },
};
